/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

'use-strict';

import { IScope } from 'angular';
import { NgTableParams } from 'ng-table';
import LogService from 'src/app/shared/services/log';
import { SalesAPIService } from '../../shared/api/sales-api.service';
import { InterfaceService } from '../../shared/interface/interface.service';
import { TradeIn } from '../../src/app/@shared-types/vehicle/tradein';

interface TradeInsScope extends IScope {
  table: NgTableParams<TradeIn>,
  tradeIns: TradeIn[] | null,
  removeAllFilter: () => void,
  removeFilter: (filter: string) => void,
  tableClick: (receiptId: number) => void,
}

/* @ngInject */
export default function TradeInsController(
  $scope: TradeInsScope,
  salesApiService: SalesAPIService,
  interfaceService: InterfaceService,
  NgTableParams: any,
  logService: LogService,
): void {
  $scope.tradeIns = null;

  const updateTableData = (tradeIns: TradeIn[]) => {
    $scope.tradeIns = tradeIns;
    $scope.table.settings({
      dataset: tradeIns,
    });
    return Promise.resolve();
  };

  const init = () => {
    $scope.table = new NgTableParams({
      sorting: {
        state: 'desc',
        id: 'desc',
      },
    });

    salesApiService.getTradeIns()
      .then((tradeIns) => updateTableData(tradeIns))
      .then(() => interfaceService.applyScope($scope))
      .catch((e) => logService.error(e));
  };

  init();
}
